import { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Stack,
  Dialog,
  DialogContent,
  useTheme,
} from "@mui/material";
import { Close, QrCode, Email, WhatsApp } from "@mui/icons-material";
import QRCode from "react-qr-code";
import { tokens } from "../../../../../../theme";

interface ShareDrawerProps {
  open: boolean;
  onClose: () => void;
  streamData: {
    website_stream_link?: string;
    title?: string;
  } | null;
}

export default function ShareDrawer({
  open,
  onClose,
  streamData,
}: ShareDrawerProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [openQr, setOpenQr] = useState(false);

  const handleWhatsAppShare = () => {
    if (!streamData?.website_stream_link) return;

    const messageTemplate = `It is with great sadness that we share the livestream link for the funeral ${streamData.title}.

You can view it here: ${streamData.website_stream_link}`;

    const text = encodeURIComponent(messageTemplate);
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  const handleEmailShare = () => {
    if (!streamData?.website_stream_link) return;

    const subjectTemplate = `Funeral Service for ${streamData.title} - Livestream Link`;
    const bodyTemplate = `Dear friends and family,

We are sharing the livestream link for the funeral service of ${streamData.title}

You can view the livestream here: ${streamData.website_stream_link}

Thank you for your thoughts and support during this difficult time.

Sincerely,`;

    const subject = encodeURIComponent(subjectTemplate);
    const body = encodeURIComponent(bodyTemplate);
    window.open(`mailto:?subject=${subject}&body=${body}`, "_blank");
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            p: 3,
          },
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              Share Memorial
            </Typography>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>

          <Stack direction="row" justifyContent="center" spacing={3}>
            <Box sx={{ textAlign: "center" }}>
              <IconButton
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: colors.primary[800],
                  color: colors.primary[100],
                  mb: 1,
                }}
                onClick={() => setOpenQr(true)}
              >
                <QrCode />
              </IconButton>
              <Typography variant="caption" display="block">
                QR Code
              </Typography>
            </Box>

            <Box sx={{ textAlign: "center" }}>
              <IconButton
                onClick={handleEmailShare}
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "red",
                  color: "white",
                  mb: 1,
                }}
              >
                <Email />
              </IconButton>
              <Typography variant="caption" display="block">
                Email
              </Typography>
            </Box>

            <Box sx={{ textAlign: "center" }}>
              <IconButton
                onClick={handleWhatsAppShare}
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: colors.grey[10],
                  color: colors.primary[900],
                  mb: 1,
                }}
              >
                <WhatsApp />
              </IconButton>
              <Typography variant="caption" display="block">
                WhatsApp
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Drawer>

      <Dialog open={openQr} onClose={() => setOpenQr(false)}>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <QRCode value={streamData?.website_stream_link || ""} size={200} />
        </DialogContent>
      </Dialog>
    </>
  );
}
